export default __webpack_public_path__ + "static/media/icon_service.e96cf9c2.svg";